import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card } from "reactstrap";
import { GetSingleProductAPI } from "network/productAPI";
import { ShowLoadingScreen } from "components/common/Loading";
import ProductForm from "./ProductForm";

export default function EditProductSection({ sectionData }) {
  const { t } = useTranslation("products");
  const navigate = useNavigate();

  const { id } = useParams();
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);

  async function getSingleData() {
    try {
      const response = await GetSingleProductAPI(
        sectionData?.uuid,
        id,
        "default"
      );
      if (response.success) {
        setEditData(response?.data);
      }
    } catch (errors) {
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getSingleData();
  }, [id, sectionData]);
  if (loading) {
    return <ShowLoadingScreen />;
  }
  return (
    <div className="AddProductForm content ">
      <Card className="p-4">
        <div className="d-flex mb-4 flex-wrap justify-content-between align-items-center ">
          <Button
            onClick={() => navigate(-1)}
            className="btn btn-primary d-flex align-items-center mb-2"
          >
            <i
              className="tim-icons icon-minimal-left
                  
                  font-weight-bold mr-2  font-size-xl"
            ></i>
            <span>{t("common.back")}</span>
          </Button>
          <h2 className="text-capitalize mb-2">
            {t("edit.title", { name: sectionData?.name })}
          </h2>
        </div>

        {editData ? (
          <ProductForm sectionData={sectionData} editData={editData} />
        ) : (
          <p className="text-center">{t("edit.notFound")}</p>
        )}
      </Card>
    </div>
  );
}
